export default "__VITE_ASSET__elENTD6r__"